import React from 'react';
import { EnumDropdown } from 'framework/form';
import { DropDownFilter } from 'framework/list';
import { EMPLOYEE_ZONES, DELEGATED_EMPLOYEE_ZONES, READ_DELEGATED_DASHBOARD_ENTRIES } from '../../constants';
import { useAuthorization } from 'framework/authorization';

type CandidateSpecializationFilterProps = {
  source: string;
  label: string;
};

const EmployeeByRetentionRiskStatusFilter = ({ source, ...props }: CandidateSpecializationFilterProps) => {
  const { isGranted } = useAuthorization();

  return (
    <DropDownFilter source={source} {...props}>
      <EnumDropdown
        source={source}
        placeholder="Risk status"
        options={isGranted(READ_DELEGATED_DASHBOARD_ENTRIES) ? DELEGATED_EMPLOYEE_ZONES : EMPLOYEE_ZONES}
        {...props}
      />
    </DropDownFilter>
  );
};

export default EmployeeByRetentionRiskStatusFilter;
